export const BUILDING_CATEGORIES = {
  defense: { label: ["palworld:build.category.defense", "Defense"] },
  food: { label: ["palworld:build.category.food", "Food"] },
  furniture: { label: ["palworld:build.category.furniture", "Furniture"] },
  infrastructure: {
    label: ["palworld:build.category.infrastructure", "Infrastructure"],
  },
  light: { label: ["palworld:build.category.light", "Lights"] },
  other: { label: ["palworld:build.category.other", "Other"] },
  pal: { label: ["palworld:build.category.pal", "Pal"] },
  product: { label: ["palworld:build.category.product", "Production"] },
  storage: { label: ["palworld:build.category.storage", "Storage"] },
  structure: { label: ["palworld:build.category.Structures", "Structures"] },
} as const;

export const BUILDING_SUB_CATEGORIES = {
  breeding: { label: ["palworld:build.subCategory.breeding", "Breeding"] },
  buildingBlock: {
    label: ["palworld:build.subCategory.buildingBlock", "Building Block"],
  },
  defense: { label: ["palworld:build.subCategory.defense", "Defense"] },
  food: { label: ["palworld:build.subCategory.food", "Food Production"] },
  furnace: { label: ["palworld:build.subCategory.furnace", "Furnace"] },
  generator: { label: ["palworld:build.subCategory.generator", "Generator"] },
  medical: { label: ["palworld:build.subCategory.medical", "Medical"] },
  medicineBench: {
    label: ["palworld:build.subCategory.medicineBench", "Medicine Bench"],
  },
  misc: { label: ["palworld:build.subCategory.misc", "Misc"] },
  palUtilities: {
    label: ["palworld:build.subCategory.palUtilities", "Pal Utilities"],
  },
  resourceProduction: {
    label: ["palworld:build.subCategory.resourceProduction", "Production"],
  },
  sphereCrafting: {
    label: ["palworld:build.subCategory.sphereCrafting", "Sphere Crafting"],
  },
  storage: { label: ["palworld:build.subCategory.storage", "Storage"] },
  trade: { label: ["palworld:build.subCategory.trade", "Trade"] },
  utility: { label: ["palworld:build.subCategory.utility", "Utility"] },
  workbench: { label: ["palworld:build.subCategory.workbench", "Workbench"] },
} as const;

export type BuildingCategory = keyof typeof BUILDING_CATEGORIES;
export type BuildingSubCategory = keyof typeof BUILDING_SUB_CATEGORIES;
